var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimelinesEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 62,
  height: 50,
  viewBox: "0 0 62 50",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E6EBF0",
  d: "M10 39v7h42v-7h4v7a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4v-7zM6 4a4 4 0 0 1 4-4h42a4 4 0 0 1 4 4v7h-4V4H10v7H6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0DAE1",
  d: "M60 31a2 2 0 1 1 0 4H45a2 2 0 1 1 0-4zm-23 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-8 0a2 2 0 1 1 0 4H8a2 2 0 1 1 0-4zm-16-8a2 2 0 1 1 0 4H8a2 2 0 1 1 0-4zm41 0a2 2 0 1 1 0 4h-5a2 2 0 1 1 0-4zm-13 0a2 2 0 1 1 0 4H21a2 2 0 1 1 0-4zm-24-8a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm37 0a2 2 0 1 1 0 4H33a2 2 0 1 1 0-4zm-29 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
}))));
export default SvgTimelinesEmpty;